import CheckCircle from 'svg/CheckCircle';
import Net from 'svg/Net';
import { DetailSection, VenueDetailCard } from 'components/Find/detail';
import type { FindVenueDetails } from 'components/Find/types';

interface Props {
  venue: FindVenueDetails;
  isCourtBooked: boolean;
  /** The host's net answer, e.g. "Bringing net" — shown under "Court booked". */
  netLabel?: string;
}

export default function MatchLocationDetails({ venue, isCourtBooked, netLabel }: Props) {
  return (
    <DetailSection title="Location details" sizeDesktop="lg">
      <div className="flex flex-col gap-ds-lg">
        {(isCourtBooked || !!netLabel) && (
          <div className="flex flex-col gap-ds-sm">
            {isCourtBooked && (
              <div className="flex items-center gap-ds-sm">
                <CheckCircle className="h-5 w-5 shrink-0 text-brand-green-400 lg:h-6 lg:w-6" />
                <span className="typography-product-caption lg:typography-product-body-highlight text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
                  Court booked
                </span>
              </div>
            )}

            {!!netLabel && (
              <div className="flex items-center gap-ds-sm">
                <Net className="h-5 w-5 shrink-0 text-color-text-lightmode-icon dark:text-color-text-darkmode-icon lg:h-6 lg:w-6" />
                <span className="typography-product-caption lg:typography-product-body-highlight text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
                  {netLabel}
                </span>
              </div>
            )}
          </div>
        )}

        <VenueDetailCard venue={venue} sizeDesktop="lg" />
      </div>
    </DetailSection>
  );
}
